var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "button",
    {
      class: _vm.styleButton,
      attrs: { type: "button" },
      on: {
        click: function ($event) {
          $event.preventDefault()
          $event.stopPropagation()
          return _vm.onClick.apply(null, arguments)
        },
      },
    },
    [
      _c(
        "span",
        {
          staticClass: "material-icons",
          class: _vm.styles.icon,
          attrs: { "aria-hidden": "true" },
        },
        [_vm._v(" " + _vm._s(_vm.stateIcon) + " ")]
      ),
      _c("span", { class: _vm.styles.label }, [_vm._t("default")], 2),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }